import type { ReactNode } from 'react'
import { classNames } from '~/utils/client/helpers'

interface DividerProps {
  children?: ReactNode
  className?: string
}

export const Divider = ({ children, className }: DividerProps) => {
  return (
    <div className={classNames('relative', className)}>
      <div className="absolute inset-0 flex items-center" aria-hidden="true">
        <div className="w-full border-t border-border-default" />
      </div>
      <div className="relative flex justify-center">{children}</div>
    </div>
  )
}

export default Divider
